import {useContext, useEffect} from "react";
import {observer} from "mobx-react";
import {useQuery} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";
import type {BookingWizardSlideComponent} from "./types";
import {XStack, YStack, Checkbox} from "@chayka/ui";
import {BookingStateContext, type TEquipment} from "../state";

export const EquipmentSlide: BookingWizardSlideComponent = observer(({setNextText}) => {
  const {data: equipmentData = []} = useQuery(trpc.booking.equipment.queryOptions());

  const {equipment, setEquipment} = useContext(BookingStateContext);

  const handleCheckboxChange = (id: number, checked: boolean) => {
    if (checked) {
      setEquipment(
        [...equipment, equipmentData.find((eq) => eq.id === id)].filter(Boolean) as TEquipment[],
      );
    } else {
      setEquipment(equipment.filter((eq) => eq.id !== id));
    }
  };

  useEffect(() => {
    setNextText?.(equipment.length > 0 ? "Далее" : "Без оборудования");
  }, [equipment, setNextText]);

  return (
    <YStack className="flex flex-col gap-4">
      {equipmentData?.map((eq) => (
        <XStack
          key={eq.id}
          className="justify-between items-center gap-4"
          onClick={() => handleCheckboxChange(eq.id, !equipment.some((e) => e.id === eq.id))}
        >
          <XStack className="gap-3 items-center flex-4">
            <Checkbox
              checked={equipment.some((e) => e.id === eq.id)}
              onChange={(checked) => handleCheckboxChange(eq.id, checked)}
            />
            <div className="font-medium">{eq.name}</div>
          </XStack>
          <div className="text-sm text-muted-foreground flex flex-1 justify-end font-bold">
            {eq.price} ₽
          </div>
        </XStack>
      ))}
    </YStack>
  );
});
